import { KLoggerDirect1gyffbbrrlqc0 as KLoggerDirect } from './KLoggerDirect.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KLoggerFactoryClass;
function KLoggerFactory() {
  if (KLoggerFactoryClass === VOID) {
    class $ {
      a2g(name) {
        return new (KLoggerDirect())(name);
      }
    }
    initMetadataForObject($, 'KLoggerFactory');
    KLoggerFactoryClass = $;
  }
  return KLoggerFactoryClass;
}
var KLoggerFactory_instance;
function KLoggerFactory_getInstance() {
  return KLoggerFactory_instance;
}
//region block: init
KLoggerFactory_instance = new (KLoggerFactory())();
//endregion
//region block: exports
export {
  KLoggerFactory_instance as KLoggerFactory_instance34piadmnvwips,
};
//endregion

//# sourceMappingURL=KLoggerFactory.mjs.map
